<script lang="ts">
  import {Icon} from '@components';
  import {createEventDispatcher} from 'svelte';
  import FeatureFlag from '@/platform-redesign-components/FeatureFlag.svelte';

  export let favorites: boolean = false;

  const dispatch = createEventDispatcher();
</script>

<FeatureFlag>
  <div slot="new_component">
    <div
      class={`flex items-center justify-center rounded-full ${
        favorites ? 'bg-neutral outline-[#F0456F]' : 'bg-slate-300'
      }`}
    >
      <div
        class={`relative h-4 w-8 cursor-pointer rounded-full outline outline-2 transition-all ${
          favorites ? 'bg-[#F0456F] outline-[#F0456F]' : 'bg-slate-300 outline-slate-300'
        }`}
        on:click={() => dispatch('filter-favorite')}
        on:keydown={() => dispatch('filter-favorite')}
      >
        <div
          class={`absolute h-4 w-4 transform rounded-full bg-white transition-all ${
            favorites ? ' translate-x-full' : ''
          }`}
        />
      </div>
    </div>
  </div>
  <label slot="current_component" for="star" on:click={() => dispatch('filter-favorite')}>
    <div class="flex cursor-pointer flex-col justify-center gap-1">
      <div class="icon-container {favorites === true ? 'bg-gray-500' : 'bg-gray-400'}">
        <Icon name="Star" className="w-10 h-10 text-white" />
      </div>
    </div>
  </label>
</FeatureFlag>

<style lang="postcss">
  .text-label {
    font-size: 10px;
  }

  .icon-container {
    @apply flex h-14 w-14 items-center justify-center rounded shadow transition-all;
  }
</style>
